/* ==========================================================================
   HOME PASSION · HESAP MENUSU + FAVORILER + ODULLER + MAGAZALAR + TEKLIF

   Butun ozellikler GERCEKTEN calisir:
     · Favoriler   localStorage'da saklanir, kalp ikonu doldurulur, rozet sayar,
                   panelden sepete eklenir, tek tek ya da toptan.
     · Teklif      kodu panoya kopyalar ve /discount/KOD ile sepete uygular.
     · Oduller     kademeler tema duzenleyiciden beslenir.
     · Magazalar   adres ve harita baglantisi tema duzenleyiciden beslenir.

   Not: bu dosya hp-assets ile birden fazla kez yuklenebilir, bu yuzden
        basta tek sefer korumasi var.
   ========================================================================== */
(function(){
  'use strict';
  if(window.__hpAccount) return;
  window.__hpAccount = 1;

  var KEY = 'hp_wish_v1';
  var OFFER_KEY = 'hp_offer_claimed_v1';

  /* ---------------- depolama ---------------- */
  function read(){
    try{ var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch(e){ return []; }
  }
  function write(list){
    try{ localStorage.setItem(KEY, JSON.stringify(list)); }catch(e){}
    sync();
  }
  function has(id){ return read().some(function(x){ return String(x.id) === String(id); }); }

  /* ---------------- para ---------------- */
  function TL(cents){
    var n = (Number(cents)||0)/100;
    try{
      return n.toLocaleString('tr-TR',{minimumFractionDigits:2, maximumFractionDigits:2}) + ' TL';
    }catch(e){ return n.toFixed(2) + ' TL'; }
  }

  /* ---------------- kisa yardimcilar ---------------- */
  function $(s,r){ return (r||document).querySelector(s); }
  function $$(s,r){ return [].slice.call((r||document).querySelectorAll(s)); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  /* ---------------- rozet + kalpler ---------------- */
  function offerClaimed(){
    try{ return localStorage.getItem(OFFER_KEY) === '1'; }catch(e){ return false; }
  }

  function sync(){
    var list = read(), n = list.length;

    /* rozet: favori varsa adedi, yoksa alinmamis teklif icin 1 */
    $$('.hpa-badge').forEach(function(b){
      var show = n > 0 ? String(n) : (offerClaimed() ? '' : '1');
      if(show){ b.textContent = show; b.hidden = false; }
      else { b.hidden = true; }
    });

    /* menudeki sayac */
    $$('[data-hpa-count]').forEach(function(e){ e.textContent = n ? '('+n+')' : ''; });

    /* kart kalpleri */
    $$('[data-wish]').forEach(function(btn){
      var id = btn.getAttribute('data-wish-id') || btn.getAttribute('data-wish');
      var on = has(id);
      btn.classList.toggle('on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Favorilerden cikar' : 'Favorilere ekle');
    });

    var p = $('#hpa-wish');
    if(p && p.classList.contains('on')) renderWish();
  }

  /* ---------------- favori ac/kapa ---------------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-wish]');
    if(!btn) return;
    e.preventDefault(); e.stopPropagation();

    var id = btn.getAttribute('data-wish-id') || btn.getAttribute('data-wish');
    if(!id) return;
    var list = read();
    var i = list.findIndex(function(x){ return String(x.id) === String(id); });

    if(i > -1){ list.splice(i,1); }
    else {
      list.unshift({
        id: id,
        vid: btn.getAttribute('data-wish-vid') || '',
        t: btn.getAttribute('data-wish-title') || '',
        p: btn.getAttribute('data-wish-price') || '',
        u: btn.getAttribute('data-wish-url') || '',
        img: btn.getAttribute('data-wish-img') || '',
        av: btn.getAttribute('data-wish-av') === '1'
      });
      pop(btn);
    }
    write(list);
  }, true);

  function pop(el){
    el.animate(
      [{transform:'scale(1)'},{transform:'scale(1.35)'},{transform:'scale(1)'}],
      {duration:320, easing:'cubic-bezier(.33,1,.68,1)'}
    );
  }

  /* ---------------- acilir menu ---------------- */
  function initMenu(){
    var wrap = $('.hpa-wrap');
    if(!wrap || wrap.dataset.hpa) return;
    wrap.dataset.hpa = '1';

    var t = null;
    var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

    function open(){ clearTimeout(t); wrap.classList.add('open'); }
    function close(){ wrap.classList.remove('open'); }

    if(fine){
      wrap.addEventListener('mouseenter', open);
      wrap.addEventListener('mouseleave', function(){ t = setTimeout(close, 160); });
    }

    /* tiklama: masaustunde de dokunmatikte de menuyu acar, hesaba gitmez */
    var trig = wrap.querySelector('.hpa-trig');
    if(trig){
      trig.addEventListener('click', function(e){
        e.preventDefault();
        wrap.classList.toggle('open');
      });
    }

    document.addEventListener('click', function(e){
      if(!wrap.contains(e.target)) close();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') close();
    });
  }

  /* ---------------- paneller ---------------- */
  function openPanel(id){
    var p = document.getElementById(id);
    if(!p) return;
    $$('.hpa-panel').forEach(function(x){ if(x !== p) x.classList.remove('on'); });
    if(id === 'hpa-wish') renderWish();
    var s = $('.hpa-scrim');
    if(s) s.classList.add('on');
    p.classList.add('on');
    document.documentElement.style.overflow = 'hidden';
    var w = $('.hpa-wrap'); if(w) w.classList.remove('open');
    var d = $('.hp-drawer'); if(d) d.classList.remove('open');
    var sc = $('.hp-scrim'); if(sc) sc.classList.remove('on');
  }
  function closePanels(){
    $$('.hpa-panel').forEach(function(x){ x.classList.remove('on'); });
    var s = $('.hpa-scrim'); if(s) s.classList.remove('on');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function(e){
    var o = e.target.closest && e.target.closest('[data-hpa-open]');
    if(o){ e.preventDefault(); openPanel(o.getAttribute('data-hpa-open')); return; }
    if(e.target.closest && e.target.closest('[data-hpa-close]')){ e.preventDefault(); closePanels(); return; }
    if(e.target.classList && e.target.classList.contains('hpa-scrim')){ closePanels(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closePanels(); });

  /* ---------------- favoriler paneli ---------------- */
  function renderWish(){
    var body = $('#hpa-wish .hpa-p-b');
    var foot = $('#hpa-wish .hpa-p-f');
    if(!body) return;
    var list = read();

    if(!list.length){
      body.innerHTML =
        '<div class="hpa-empty">'+
        '<svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-7-9.2A4 4 0 0112 8a4 4 0 017 2.8C19 15.6 12 20 12 20z"/></svg>'+
        '<h4>Favori listen henüz boş</h4>'+
        '<p>Beğendiğin parçaların kalbine dokun, burada seni beklesinler.</p>'+
        '<a class="hpa-btn" href="'+esc((window.HP_DC && window.HP_DC.shopUrl) || '/collections/all')+'">Koleksiyonu keşfet</a>'+
        '</div>';
      if(foot) foot.hidden = true;
      return;
    }
    if(foot) foot.hidden = false;

    var tk = (window.HP_DC && window.HP_DC.taksit) || 0;

    body.innerHTML = list.map(function(x){
      var price = Number(x.p) || 0;
      var taksit = (tk > 1 && price > 0)
        ? '<div class="hpa-w-tk">'+tk+' taksit × '+TL(price/tk)+'</div>' : '';
      return '<div class="hpa-w" data-row="'+esc(x.id)+'">'+
        '<a class="hpa-w-i" href="'+esc(x.u)+'">'+ (x.img ? '<img src="'+esc(x.img)+'" alt="" loading="lazy">' : '') +'</a>'+
        '<div>'+
          '<a class="hpa-w-t" href="'+esc(x.u)+'">'+esc(x.t)+'</a>'+
          '<div class="hpa-w-p">'+ (price ? TL(price) : '') +'</div>'+
          taksit +
          (x.vid
            ? '<button class="hpa-w-add" type="button" data-add="'+esc(x.vid)+'">Sepete ekle</button>'
            : '<a class="hpa-w-add" href="'+esc(x.u)+'" style="display:inline-flex;align-items:center;text-decoration:none">Ürünü gör</a>') +
        '</div>'+
        '<button class="hpa-w-x" type="button" data-del="'+esc(x.id)+'" aria-label="Favorilerden çıkar">'+
          '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'+
      '</div>';
    }).join('');

    var total = list.reduce(function(a,x){ return a + (Number(x.p)||0); }, 0);
    var tot = $('#hpa-wish [data-wish-total]');
    if(tot) tot.textContent = TL(total);
  }

  /* satir islemleri */
  document.addEventListener('click', function(e){
    var del = e.target.closest && e.target.closest('[data-del]');
    if(del){
      var id = del.getAttribute('data-del');
      write(read().filter(function(x){ return String(x.id) !== String(id); }));
      return;
    }
    var add = e.target.closest && e.target.closest('[data-add]');
    if(add && add.tagName === 'BUTTON'){
      addToCart(add.getAttribute('data-add'), add);
      return;
    }
    var all = e.target.closest && e.target.closest('[data-add-all]');
    if(all){ addAll(all); }
  });

  function addToCart(vid, btn){
    if(!vid) return;
    var old = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Ekleniyor…'; }
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items:[{ id: Number(vid), quantity: 1 }] })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(){
        if(btn){ btn.textContent = 'Sepete eklendi ✓'; }
        refreshCount();
        setTimeout(function(){ if(btn){ btn.disabled = false; btn.textContent = old; } }, 1600);
      })
      .catch(function(){
        if(btn){ btn.disabled = false; btn.textContent = 'Eklenemedi'; 
          setTimeout(function(){ btn.textContent = old; }, 1600); }
      });
  }

  function addAll(btn){
    var items = read().filter(function(x){ return x.vid; })
                      .map(function(x){ return { id: Number(x.vid), quantity: 1 }; });
    if(!items.length) return;
    var old = btn.textContent;
    btn.disabled = true; btn.textContent = 'Ekleniyor…';
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ items: items })
    }).then(function(r){ return r.ok ? r.json() : Promise.reject(r); })
      .then(function(){
        btn.textContent = items.length + ' ürün sepete eklendi ✓';
        refreshCount();
        setTimeout(function(){ btn.disabled = false; btn.textContent = old; }, 2000);
      })
      .catch(function(){
        btn.disabled = false; btn.textContent = 'Eklenemedi';
        setTimeout(function(){ btn.textContent = old; }, 1800);
      });
  }

  function refreshCount(){
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        $$('[data-cart-count]').forEach(function(e){ e.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('hp:cart:updated', {detail:c}));
      }).catch(function(){});
  }

  /* ---------------- teklif ---------------- */
  document.addEventListener('click', function(e){
    var c = e.target.closest && e.target.closest('[data-hpa-copy]');
    if(c){
      var code = c.getAttribute('data-hpa-copy');
      var done = function(){
        var old = c.textContent; c.textContent = 'Kopyalandı ✓';
        try{ localStorage.setItem(OFFER_KEY,'1'); }catch(err){}
        sync();
        setTimeout(function(){ c.textContent = old; }, 1800);
      };
      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; ta.style.position='fixed'; ta.style.opacity='0';
        document.body.appendChild(ta); ta.select();
        try{ document.execCommand('copy'); }catch(err){}
        document.body.removeChild(ta); done();
      }
      return;
    }
    var ap = e.target.closest && e.target.closest('[data-hpa-apply]');
    if(ap){
      try{ localStorage.setItem(OFFER_KEY,'1'); }catch(err){}
      /* Shopify indirim kodunu oturuma islet, sonra alisverise don */
      var code2 = ap.getAttribute('data-hpa-apply');
      var back  = ap.getAttribute('data-hpa-return') || '/collections/all';
      location.href = '/discount/' + encodeURIComponent(code2) +
                      '?redirect=' + encodeURIComponent(back);
    }
  });

  /* ---------------- baslat ---------------- */
  function boot(){ initMenu(); sync(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); }
  else { boot(); }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('storage', function(e){ if(e.key === KEY) sync(); });

  /* disariya kucuk bir API */
  window.HPWish = { get: read, count: function(){ return read().length; }, sync: sync };
})();
